import React from "react";
import LegalPage from "../../components/Legal/LegalPage.jsx";
import privacyPolicy from "./privacyPolicyData.js";

const PrivacyPolicy = () => <LegalPage policy={privacyPolicy} />;

export default PrivacyPolicy;
